<template>
    <div class="">
        <div class="hidden sm:flex rounded-md shadow-sm w-60 ml-10">
            <Listbox as="div" v-model="selected"
                     @update:modelValue="onUpdateSelection($event)"
                     class="flex flex-column sm:flex-row w-full">
                <div class="relative w-full block">
                    <ListboxButton
                        class="relative h-input w-full bg-white border border-cyan-700 shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm">
                        <span class="block truncate">{{ selected.name }}</span>
                        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronUpIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
        </span>
                    </ListboxButton>

                    <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                                leave-to-class="opacity-0">
                        <ListboxOptions
                            class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                            <ListboxOption as="template" v-for="option in options" :key="option.id" :value="option"
                                           v-slot="{ active, selected }">
                                <li :class="[active ? 'text-white bg-cyan-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-8 pr-4']">
              <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                {{ option.name }}
              </span>

                                    <span v-if="selected"
                                          :class="[active ? 'text-white' : 'text-cyan-600', 'absolute inset-y-0 left-0 flex items-center pl-1.5']">
                <CheckIcon class="h-5 w-5" aria-hidden="true"/>
              </span>
                                </li>
                            </ListboxOption>
                        </ListboxOptions>
                    </transition>
                </div>
            </Listbox>

            <button type="button"
                    @click="toggleDirection"
                    class="relative inline-flex items-center px-4 py-2 border border-cyan-600 text-sm font-medium rounded-r-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-cyan-500">
                <BarsArrowUpIcon v-show="direction === 'desc'" class="h-5 w-5" aria-hidden="true"/>
                <BarsArrowDownIcon v-show="direction === 'asc'" class="h-5 w-5" aria-hidden="true"/>
            </button>
        </div>

    </div>

    <button
        :class="open ? '' : 'text-opacity-90'"
        @click="toggle"
        class="sm:hidden h-input inline-flex items-center px-3 py-2 text-base font-medium text-white border-cyan-600 bg-cyan-600 rounded-r-md hover:bg-cyan-700 group hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
    >
        <ChevronUpIcon
            :class="open ? '' : 'text-opacity-70'"
            class="w-5 h-5 ml-2 text-orange-300 transition duration-150 ease-in-out group-hover:text-opacity-80"
            aria-hidden="true"
        />
    </button>

    <OverlayPanel ref="op" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '450px'}">
        <div class="rounded-md shadow-sm flex">
            <Listbox as="div" v-model="selected"
                     @update:modelValue="onUpdateSelection($event)"
                     class="w-full">
                <div class="relative w-full">
                    <ListboxButton
                        class="relative h-input w-full bg-white border border-cyan-700 shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm">
                        <span class="block truncate">{{ selected.name }}</span>
                        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronUpIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
        </span>
                    </ListboxButton>

                    <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                                leave-to-class="opacity-0">
                        <ListboxOptions
                            class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                            <ListboxOption as="template" v-for="option in options" :key="option.id" :value="option"
                                           v-slot="{ active, selected }">
                                <li :class="[active ? 'text-white bg-cyan-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-8 pr-4']">
              <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                {{ option.name }}
              </span>

                                    <span v-if="selected"
                                          :class="[active ? 'text-white' : 'text-cyan-600', 'absolute inset-y-0 left-0 flex items-center pl-1.5']">
                <CheckIcon class="h-5 w-5" aria-hidden="true"/>
              </span>
                                </li>
                            </ListboxOption>
                        </ListboxOptions>
                    </transition>
                </div>
            </Listbox>

            <button type="button"
                    @click="toggleDirection"
                    class="rounded-l-none relative inline-flex items-center px-4 py-2 border border-cyan-600 text-sm font-medium rounded-r-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-cyan-500">
                <BarsArrowUpIcon v-show="direction === 'desc'" class="h-5 w-5" aria-hidden="true"/>
                <BarsArrowDownIcon v-show="direction === 'asc'" class="h-5 w-5" aria-hidden="true"/>
            </button>
        </div>

    </OverlayPanel>


</template>

<script>
import {ref} from 'vue'
import {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    TransitionChild,
    TransitionRoot
} from '@headlessui/vue'
import {CheckIcon, ChevronUpIcon} from '@heroicons/vue/20/solid'
import {BarsArrowDownIcon, BarsArrowUpIcon} from "@heroicons/vue/24/outline";
import Button from "@/Jetstream/PrimaryButton";
import JetDialogModal from "@/Jetstream/DialogModal";
import OverlayPanel from "primevue/overlaypanel";

export default {
    props: ['modelValue', 'options'],
    emits: ['update:modelValue'],
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ChevronUpIcon,
        BarsArrowUpIcon,
        BarsArrowDownIcon,
        TransitionRoot,
        TransitionChild,
        JetDialogModal,
        Button,
        OverlayPanel
    },
    setup(props) {
        const open = ref(false);
        let field = props.modelValue;
        let direction = ref("asc");

        let splitted = field.split("-");
        if (splitted.length > 1) {
            field = field.replace("-", "");
            direction = 'desc';
        }

        const selected = ref(props.options.find(p => p.id === field))
        return {
            selected,
            direction,
            field,
            open,
        }
    },
    watch: {
        modelValue: function (val) {
            let splitted = val.split("-");
            if (splitted.length > 1) {
                this.field = val.replace("-", "");
                this.direction = 'desc';
            }
            this.selected = this.options.find(p => p.id === this.field);
        }
    },
    methods: {
        onUpdateSelection(event) {
            this.updateSort(event.id)
        },
        toggleDirection() {
            this.direction = this.direction === 'asc' ? "desc" : "asc";
            this.updateSort(this.field)
        },
        updateSort(field) {
            this.field = field;
            this.$emit('update:modelValue', this.direction === 'asc' ? field : `-${field}`)
        },
        toggle(event) {
            this.open = !this.open;
            this.$refs.op.toggle(event);
        },
    },
}
</script>
